<div class="advisory__wrapper" *ngIf="!!title">
    <h1 class="advisory__content-title" test-target="advisory__content-title">{{title}}</h1>
</div>
